import $ from "jquery";
import { bindButtonClick } from "./buttonbind";

/* eslint-disable */
export default function popout() {
  $(".popout-close, .popout-overlay").click(function () {
    $(".popout-overlay").css("opacity", 0);
    $(".popout-box").delay(500).fadeOut();
    $(".popout-box-form").delay(500).fadeOut();
    $(".popout-enquiry-form").delay(500).fadeOut();
    $(".popout-inner").css("right", "-720px");
    $(".popout-inner .plyr").delay(500).html("");
  });

  bindButtonClick();
}
